function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: .2,
  d: "M20.599 2.236h-1.317v-.46a.396.396 0 0 0-.28-.396 10.683 10.683 0 0 0-2.792-.365c-1.55 0-3.661.357-5.223 1.982-1.55-1.641-3.676-1.982-5.222-1.982-.942-.002-1.881.12-2.793.365a.396.396 0 0 0-.279.396v.456H1.387A.392.392 0 0 0 1 2.628v12.658c0 .218.173.396.387.396a.38.38 0 0 0 .19-.052c.039-.02 3.913-2.187 9.321-.792h.093a.38.38 0 0 0 .093 0c5.424-1.407 9.298.757 9.321.792.12.071.268.071.388 0 .119-.07.193-.2.193-.34V2.631a.392.392 0 0 0-.387-.396zM1.775 14.656V3.027H2.7v9.94a.392.392 0 0 0 .445.396c.802-.126 1.61-.192 2.422-.199a9.842 9.842 0 0 1 3.308.512 13.95 13.95 0 0 0-7.101.978zm3.793-2.28a16.67 16.67 0 0 0-2.108.14V2.088c.754-.172 1.525-.26 2.297-.262 1.45 0 3.448.341 4.835 1.942l.012 9.872c-.806-.539-2.379-1.264-5.036-1.264zm5.81-8.607c1.388-1.585 3.387-1.942 4.836-1.942.772.003 1.543.09 2.297.262v10.426a16.665 16.665 0 0 0-2.096-.142c-2.642 0-4.219.725-5.036 1.264V3.769zm8.83 10.886a13.953 13.953 0 0 0-7.117-.978 9.865 9.865 0 0 1 3.324-.512c.816.005 1.63.07 2.437.195a.389.389 0 0 0 .445-.397V3.028h.926l-.015 11.627z"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 22,
  height: 16,
  viewBox: "0 0 22 16"
}, props), _ref);

export default __webpack_public_path__ + "static/media/ig-stories.86a728e7.svg";
export { SvgComponent as ReactComponent };